import { render, staticRenderFns } from "./modal-transferir-conversa.vue?vue&type=template&id=fe07b4e2&"
import script from "./modal-transferir-conversa.vue?vue&type=script&lang=js&"
export * from "./modal-transferir-conversa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe07b4e2')) {
      api.createRecord('fe07b4e2', component.options)
    } else {
      api.reload('fe07b4e2', component.options)
    }
    module.hot.accept("./modal-transferir-conversa.vue?vue&type=template&id=fe07b4e2&", function () {
      api.rerender('fe07b4e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/modal/modal-transferir-conversa/modal-transferir-conversa.vue"
export default component.exports